import { EDevice, LOCAL_STORAGE_KEYS, QUERY_PARAMS } from '@/constants';
import {
  isDeviceAndroid,
  isDeviceIos
} from '@/modules/perseo-billing/utils/device-detector';

const buildBuyNowPurchaseSearchParams = (
  orderId: string | undefined
): URLSearchParams => {
  const search = new URLSearchParams(window.location.search);
  search.set('orderId', orderId ?? '');

  // Add FastCheckout query parameter for order confirmation tracking
  search.set('orderType', 'FastCheckout');

  if (isDeviceAndroid()) {
    search.set(QUERY_PARAMS.DEVICE, EDevice.ANDROID);
  }

  if (isDeviceIos()) {
    search.set(QUERY_PARAMS.DEVICE, EDevice.IOS);
  }

  const hasDevice = search.get(QUERY_PARAMS.DEVICE);
  if (hasDevice) return search;

  const storageDevice = getBuyNowDeviceLocalStorage();
  const isAndroid = storageDevice === EDevice.ANDROID;
  const isIos = storageDevice === EDevice.IOS;
  const isKiosco = storageDevice === EDevice.KIOSCO;
  if (isAndroid || isIos || isKiosco) {
    search.set(QUERY_PARAMS.DEVICE, storageDevice);
  }
  return search;
};

const getBuyNowDeviceLocalStorage = () => {
  const device = localStorage.getItem(LOCAL_STORAGE_KEYS.DEVICE);
  if (!device) return '';
  if (device === 'web') return '';
  return device;
};

export { buildBuyNowPurchaseSearchParams };
